import { removeExistingPlayer } from './removeExistingPlayer';
import { createAndPlayPlayer } from './createAndPlayPlayer';

export const dashPlayerInit = () => {
  const playButton = document.querySelector('.header_trailer-play');

  if (playButton) {
    const mediaSection = document.querySelector('.header_trailer-media');
    const trailerId = playButton.getAttribute('data-trailer-id');

    playButton.addEventListener('click', () => {
      removeExistingPlayer();
      createAndPlayPlayer(trailerId, mediaSection);
    });
  }
};
